import { addDays, addHours, nextMonday, startOfHour } from 'date-fns';
import { IDueDateValue, moveDueDateToDay } from './buckets';

export type SnoozeOptionId = 'laterToday' | 'tomorrow' | 'nextMonday' | 'inAWeek' | 'clear';

export interface ISnoozeOption {
	id: SnoozeOptionId;
	label: string;
}

export function getSnoozeOptions(current: IDueDateValue): ISnoozeOption[] {
	const options: ISnoozeOption[] = [];
	if (current.hasDueTime) {
		options.push({ id: 'laterToday', label: 'Later today' });
	}
	options.push(
		{ id: 'tomorrow', label: 'Tomorrow' },
		{ id: 'nextMonday', label: 'Next Monday' },
		{ id: 'inAWeek', label: 'In a week' }
	);
	if (current.dueDate) {
		options.push({ id: 'clear', label: 'Clear date' });
	}
	return options;
}

export function snoozeTo(id: SnoozeOptionId, current: IDueDateValue, now = new Date()): IDueDateValue {
	switch (id) {
		case 'laterToday':
			return { dueDate: startOfHour(addHours(now, 3)).toISOString(), hasDueTime: true };
		case 'tomorrow':
			return moveDueDateToDay(addDays(now, 1), current);
		case 'nextMonday':
			return moveDueDateToDay(nextMonday(now), current);
		case 'inAWeek':
			return moveDueDateToDay(addDays(now, 7), current);
		case 'clear':
		default:
			return { dueDate: null, hasDueTime: false };
	}
}
